angular = require('angular')

app = angular.module('workflow.app')
app.directive( 'divLoader', require('./divLoader') )
